import Rollbar from 'rollbar';
import {ignoredMessages} from './ignore';

const stagingOrProduction = ['production', 'staging'].includes(__ENV__);
const isK8s = process.env.K8S_DEPLOYMENT === 'true';

const getAccessToken = () => {
  if (isK8s) {
    return __ENV__ === 'production'
      ? process.env.ROLLBAR_JS_ACCESS_TOKEN_PROD
      : process.env.ROLLBAR_JS_ACCESS_TOKEN_STAGING;
  }
  return process.env.ROLLBAR_JS_ACCESS_TOKEN;
};

const accessToken = getAccessToken();

const rollbar = new Rollbar({
  accessToken: accessToken,
  captureUncaught: stagingOrProduction,
  captureUnhandledRejections: stagingOrProduction,
  enabled: true,
  hostSafeList: ['customink.com'],
  ignoredMessages,
  payload: {
    environment: isK8s ? `${__ENV__}-k8s` : __ENV__,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
});

export default rollbar;
